import axios from 'axios'

export default {
  namespaced: true,
  state: {
    requestProperties: null
  },

  getters: {
    propertyLabel: (state) => (propertyCode) => {
      if (state.requestProperties == null) {
        return propertyCode
      }
      for (const p of state.requestProperties) {
        if (p.property_code === propertyCode) {
          return p.property_display_name
        }
      }
      return propertyCode
    },

    hasProperty: (state) => (propertyCode) => {
      if (state.requestProperties == null) {
        return false
      }
      for (const p of state.requestProperties) {
        if (p.property_code === propertyCode) {
          return true
        }
      }
      return false
    },

    propertyIsVisible: (state) => (propertyCode) => {
      if (state.requestProperties == null) {
        return false
      }
      for (const p of state.requestProperties) {
        if (p.property_code === propertyCode) {
          return p.is_visible
        }
      }
      return false
    },

    propertyIsEditable: (state) => (propertyCode) => {
      if (state.requestProperties == null) {
        return false
      }
      for (const p of state.requestProperties) {
        if (p.property_code === propertyCode) {
          return p.is_editable
        }
      }
      return false
    }
  },

  mutations: {
    setRequestProperties (state, data) {
      state.requestProperties = data
    }
  },

  actions: {
    retrieveClientRequestProperties ({commit, state}, client) {
      if (state.requestProperties != null) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        axios.get(process.env.API + `${client}/request-properties`).then(data => {
          commit('setRequestProperties', data.data)
          resolve()
        })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client.js